module.exports = __webpack_public_path__ + "static/media/37550025-jjE0wSgs.210e4195.JPG";